var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayWhiteOutlineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.366V2.63471C1 1.91473 1 1.55435 1.1334 1.34132C1.24984 1.1554 1.4293 1.03333 1.62854 1.00415C1.85673 0.970722 2.13661 1.14025 2.69557 1.47882L9.90299 5.84445L9.90561 5.84576C10.5233 6.21992 10.8323 6.40709 10.9337 6.65655C11.0221 6.87417 11.0221 7.12538 10.9337 7.343C10.8322 7.59281 10.5225 7.78074 9.90299 8.15596L2.69557 12.5216C2.13621 12.8604 1.85682 13.0293 1.62854 12.9958C1.4293 12.9667 1.24984 12.8446 1.1334 12.6587C1 12.4457 1 12.0859 1 11.366Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayWhiteOutlineIcon);
export default __webpack_public_path__ + "static/media/play-white-outline-icon.42f7b12cae58c90b007a2c6bbbbefd4f.svg";
export { ForwardRef as ReactComponent };